/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React, { useState,
useEffect } from 'react'
import {
Image,
Text,
View,
ScrollView,
TouchableOpacity,
SafeAreaView,
Platform} from 'react-native';
import { Loader } from '../../components';
import { TutorialDeviceStorage } from '../../utilities';
import styles from './styles';
import { Firestore, Crashlytics, getAuth } from '../../firebase/config';
import * as Linking from 'expo-linking';
import * as Updates from 'expo-updates';
import {
Icon,
ListItem,
BottomSheet } from 'react-native-elements';
import { LinearGradient } from 'expo-linear-gradient';
import { APPLICATION_VERSION,
COPYRIGHT_YEAR } from "@env";


export default function AboutScreen({navigation}) {
const [contact, setContact] = useState({});
const [loading, setLoading] = useState(true);
const [bottomSheetVisible, setBottomSheetVisible] = useState(false);
const contactRef = Firestore.collection('Public').doc('Contact');
const auth = getAuth();
const user = auth.currentUser;

useEffect(() => {
contactRef.get().then((doc) => {
const data = doc.data();
data.id = doc.id;
setContact(data);
setLoading(false);
}).catch((err) => {
setLoading(false);
console.error("Error fetching contact information: ", err);
Crashlytics.recordError(err);
})
},[])


const callSupport = () => {
return Linking.openURL('tel:15854922780');
}

const emailSupport = () => {
return Linking.openURL('mailto:info@empiredistributing.net?subject=Empire Distributing App Support');
}

const becomeADealer = () => {
return Linking.openURL(contact.newDealerInquiryURL || 'https://empiredistributing.net/contact.html');
}

const viewTutorial = () => {
TutorialDeviceStorage.clearTutorial();
Updates.reloadAsync();
};


  if (loading) {
    return (
    <Loader />
    )
  }

    return (
     <View style={{flex: 1}}>
               <LinearGradient
                colors={['black', '#590000']}
                locations={[.1,1]}
                style={{flex: 1}}
                >
        <SafeAreaView style={styles.container}>
        <ScrollView
         style={{width: '100%' }}
         >
        <Image
        style={styles.logo}
        source={require('../../../assets/empireLogoTransparent.png')}
        />
        <View style={styles.actionContainer}>
                           <TouchableOpacity
                           style={[styles.button, {marginTop: 40}]}
                           onPress={() => setBottomSheetVisible(!bottomSheetVisible)}>
                          <Text style={styles.buttonTitle}>Contact Support</Text>
                          </TouchableOpacity>
                          {!user &&
                          <>
                          <TouchableOpacity
                           style={styles.button}
                           onPress={() => becomeADealer()}>
                          <Text style={styles.buttonTitle}>Become a Dealer</Text>
                          </TouchableOpacity>
                          {Platform.OS !='web' &&
                          <TouchableOpacity
                           style={styles.button}
                           onPress={() => viewTutorial()}>
                          <Text style={styles.buttonTitle}>View Tutorial</Text>
                          </TouchableOpacity>
                          }
                          </>
                          }
                           </View>
                          <View style={styles.footerView}>
                          <Text style={{color:'white', paddingBottom: 20}}>Connect With Us Elsewhere</Text>
                          <View style={styles.socialLinks}>
                          <View style={styles.socialLinkSpacing}>
                          <Icon raised name="facebook" onPress={() => {Linking.openURL(contact.facebookURL)}}/>
                          <Text style={styles.iconText}>Facebook</Text>
                         </View>
                         <View style={styles.socialLinkSpacing}>
                         <Icon raised name="shopping-cart" onPress={() => {Linking.openURL(contact.onlineOrderingURL)}}/>
                         <Text style={styles.iconText}>Online Ordering</Text>
                         </View>
                         <View style={styles.socialLinkSpacing}>
                         <Icon raised name="fireplace" onPress={() => {Linking.openURL(contact.infernoURL)}}/>
                         <Text style={styles.iconText}>Inferno</Text>
                         </View>
                          </View>
                          </View>
                          <View style={styles.footerInfo}>
                          <View style={{flexDirection: 'row', justifyContent: 'center', marginTop: '10%', marginBottom: '1%'}}>
                          <Text style={styles.footerLink} onPress={() => navigation.navigate('Legal', {document: 'terms'})}>Terms & Conditions</Text>
                          <Text style={styles.footerLink}> | </Text>
                          <Text style={styles.footerLink} onPress={() => navigation.navigate('Legal', {document: 'privacy'})}>Privacy Policy</Text>
                          </View>
                          <Text style={[styles.footerLink, {marginBottom: 20}]} onPress={() => {navigation.navigate('Legal', {document: 'attribution'})}}>Open Source</Text>
                          <Text style={styles.footerText}>
                          &copy; {COPYRIGHT_YEAR} Countryside Stove & Chimney, Inc. | All Rights Reserved
                          {'\n'}
                          App Version {APPLICATION_VERSION}
                          </Text>
                          </View>
                          <BottomSheet
                          isVisible={bottomSheetVisible}>
                          <ListItem
                          containerStyle={styles.bottomSheetBackground}
                          onPress={() => {callSupport()}}
                          bottomDivider={true}
                          >
                              <Icon name="phone-outline" type={'material-community'} size={30} color={'green'} />
                              <ListItem.Content>
                              <ListItem.Title><Text style={styles.listItemText}>Call</Text></ListItem.Title>
                              </ListItem.Content>
                              <ListItem.Subtitle><Text style={styles.listItemText}>(585) 492-2780</Text></ListItem.Subtitle>
                              </ListItem>
                                   <ListItem
                                   containerStyle={styles.bottomSheetBackground}
                                   onPress={() => {emailSupport()}}
                                   bottomDivider={true}
                                   >
                                   <Icon name="email-outline" type={'material-community'} size={30} color={'orange'} />
                                   <ListItem.Content>
                                   <ListItem.Title><Text style={styles.listItemText}>Email</Text></ListItem.Title>
                                   </ListItem.Content>
                                   <ListItem.Subtitle><Text style={styles.listItemText}>info@empiredistributing.net</Text></ListItem.Subtitle>
                                   </ListItem>
                                   <ListItem
                                   containerStyle={styles.bottomSheetBackground}
                                   onPress={() => {setBottomSheetVisible(!bottomSheetVisible)}}
                                   >
                                   <Icon name="cancel" type={'material-community'} size={30} color={'red'} />
                                   <ListItem.Content>
                                   <ListItem.Title><Text style={{color: 'red'}}>Cancel</Text></ListItem.Title>
                                   </ListItem.Content>
                                   </ListItem>
                          </BottomSheet>
        </ScrollView>
        </SafeAreaView>
        </LinearGradient>
        </View>
    )
}
